import React,  { useState,useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as moment from 'moment';
import ReactJSBarcode from 'react-jsbarcode';
// import JsBarcode from 'jsbarcode';
// var JsBarcode = require('jsbarcode');
// var Barcode = require('react-barcode');
// var Canvas = require("canvas");
function BagTag(props) {
 
//   debugger;
//   console.log('btag---------', props.location.state, props.data)
  const dispatch = useDispatch();
  const bagTagData =  props.data !== undefined && props.data && props.data.length ? props.data : props.location.state.data && props.location.state.data.length ? props.location.state.data : [];
  const stSearchedRecordData= useSelector(state=>state.search.SearchedRecordData);
  const SearchedFlightDetails= useSelector(state=>state.search.SearchedFlightDetails);
  const SearchedSelectedPassengerData= useSelector(state=>state.selectedpassenger.SelectedPassengerData);
//   const [BagTagDataForTransfer, setBagTagDataForTransfer] = useState(props!=""? props.data:[]);
  const [BagTagDataForTransfer, setBagTagDataForTransfer] = useState(bagTagData);
  const [recordLocator, setrecordLocator] = useState(SearchedFlightDetails.recordLocator);
  const lrtBagType = useSelector(state => state.search.lrtBagTypeForPassenger);
//   console.log('btag---------', lrtBagType, bagTagData);
  debugger
//   const [origin, setorigin] = useState(SearchedFlightDetails.journeys[0].designator.origin);
  const [destination, setdestination] = useState(SearchedFlightDetails.journeys[0].designator.destination);
  const [departureDate, setdepartureDate] = useState(SearchedFlightDetails.journeys[0].designator.departure);
  const [sequenceNumber, setsequenceNumber] = useState(SearchedFlightDetails.journeys[0].segments[0].passengerSegment[0].boardingSequence);
  const [totalPieces, settotalPieces] = useState(SearchedFlightDetails.journeys[0].designator.departure);
  const [flightnumber, setflightnumber] = useState(SearchedFlightDetails.journeys[0].segments[0].identifier.carrierCode+" "+SearchedFlightDetails.journeys[0].segments[0].identifier.identifier);
  const selectedJourney = SearchedFlightDetails.journeys.map(j => j.segments.filter(seg => seg.IsSelected)).filter(jarr => jarr.length);
    let BagsTagToPrint = BagTagDataForTransfer.filter(pax => pax.IsSelected);
    let a = '';
    // console.log('BagsTagToPrint in  bagtag component', BagsTagToPrint);
    BagsTagToPrint.forEach((passenger) => {
        passenger.bags.filter(bag => bag.IsSelected).forEach((paxBag) => {
            
            let segIndexToShow =  selectedJourney[0].length === 1 ? 0 : selectedJourney[0].findIndex(seg => seg.IsSelected && (seg.identifier.identifier === paxBag.identifier));
            let segIndexToShowSeq =  selectedJourney[0].length === 1 ? 0 : selectedJourney[0].findIndex(seg => seg.IsSelected && (seg.identifier.identifier !== paxBag.identifier));
            let flightName = selectedJourney[0][segIndexToShow];
            paxBag.origin = selectedJourney[0][0].designator.origin;
            paxBag.flightnumberAtTop = `${flightName.identifier.carrierCode} ${flightName.identifier.identifier}`;
            paxBag.destAtTop = flightName.designator.destination;
            if (lrtBagType && lrtBagType[passenger.passengerKey] && lrtBagType[passenger.passengerKey].find(b => b.bagWeight === paxBag.weight)) {

                paxBag.isLrt = true;
            } else {
                paxBag.isLrt = false;
            }
            paxBag.seqAtTop = selectedJourney[0][segIndexToShowSeq].passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence;
            let psegForOsTagUnderBarCode = flightName.passengerSegment.filter(pseg => pseg.IsSelected && pseg.passengerKey === passenger.passengerKey)[0];
            let psegBagForOsTagUnderBarCode = psegForOsTagUnderBarCode.bags.filter(psegBag => psegBag.baggageKey === paxBag.baggageKey)[0].osTag;
            paxBag.osTagUnderBarCode = psegBagForOsTagUnderBarCode;
            paxBag.table = [];
            if (segIndexToShow === 0) {
                const segmentForTable = selectedJourney[0][segIndexToShow];
                const bagTagDetailObject = {
                    taggedToStation: segmentForTable.designator.destination,
                    flightNumber: `${segmentForTable.identifier.carrierCode} ${segmentForTable.identifier.identifier}`,
                    depDate: moment(segmentForTable.designator.departure).format("D MMM, YYYY"),
                    seqNo: segmentForTable.passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence
                }
                paxBag.table.push(bagTagDetailObject);
            } else {
                const segmentsForTable = selectedJourney[0];
                segmentsForTable.forEach((seg) => {
                    const bagTagDetailObject = {
                        taggedToStation: seg.designator.destination,
                        flightNumber: `${seg.identifier.carrierCode} ${seg.identifier.identifier}`,
                        depDate: moment(seg.designator.departure).format("D MMM, YYYY"),
                        seqNo: seg.passengerSegment.filter(pseg => pseg.IsSelected && (pseg.passengerKey === passenger.passengerKey))[0].boardingSequence
                    }
                    paxBag.table.push(bagTagDetailObject);
                })
            }
            paxBag.table.forEach((trow, index, array) => {
                a = array.length > 1 && index === 0 ? '' : trow.taggedToStation
            })
        })
    });
    console.log('BagsTagToPrint in  bagtag component', BagsTagToPrint);

    const additionalTrForDirectAndConnecting = (bt, item, j) => {
        
        const selectedBags = item.bags.filter(items => items.IsSelected);
        // console.log('bt, item, j, selectedBags', bt, item, j,selectedBags );
        if ( bt.table.length === 1 && selectedBags.length-1 !== j) {
            // console.log(' bt.table.length === 1 && selectedBags.length-1 !== j height="76"')
            return (
            <tr>
                <td height="76" style={{"font-size":"30px"}}>
                </td>
            </tr>)
        }

        else if (bt.table.length > 1 && selectedBags.length-1 !== j ) {
            // console.log('bt.table.length > 1 && selectedBags.length-1 !== j height="67"')
            return (
                <tr>
                    <td height="67" style={{"font-size":"30px"}}>
                    </td>
                </tr>
            )
        } else {
            // console.log('null')
            return null;
        }
    }

    const checkDirectOrConnecting = (bt, item, j) => {
        const selectedBags = item.bags.filter(items => items.IsSelected);
        let height = '2150px';
        // console.log('bt, item, j, selectedBags', bt, item, j,selectedBags );
        if ( bt.table.length === 1) {
            // if (selectedBags.length-1 !== j) {
                // console.log(' bt.table.length === 1 && selectedBags.length-1 !== j height="76"')
                height = '2150px'
                // return {}
            // }
        }

        if (bt.table.length > 1) {
            // console.log('bt.table.length > 1 && selectedBags.length-1 !== j height="67"')
            height = '2180px';
        }
        return height;
        // return {"width":"230px", "height": height };
    }
    
//   useEffect(() => {
       

//     // debugger;
//     // JsBarcode("#barcode", "1234567890", {
//     //   format: "EAN13",
//     //   displayValue: false
//     // });{seg.origin + "(" + moment(seg.departureTime).format('D MMM, HH:mm') + ")"}
//       }, []);
    // console.log('bt.table.length > 1',BagsTagToPrint);
  return (
   <div id="bagTag">
    {BagsTagToPrint.length==0?"":BagsTagToPrint.map((item,i) => 
              item.bags.length==0?"":item.bags.filter(items => items.IsSelected).map((bt,j) => 
            //   bt.IsSelected ?
            //   style={{"page-break-before":"always"}}
              <div style={{"width":"230px", "height": checkDirectOrConnecting(bt, item, j) }} class="child" id={"bagTag"+i+j}>
                <table style={{"width":"230px","minWidth":"230px","paddingRight":"10px"}}>
                    
                <tr><td>
              <table style={{"fontSize":"16px","lineHeight":"normal","color":"black","border":"1px black solid","maxWidth":"205px"}} width="205" height={bt.table.length > 1 ? "1700" : "1720"} border="0" cellspacing="0" cellpadding="0" align="left">
             
              <tr>
                  <td style={{"padding":"10px"}} height="250" valign="top" class="">
                      <table border="0" cellspacing="0" cellpadding="0" width="190">
                          <tbody>
                              <tr>
                                  <td style={{"fontWeight":"700","letterSpacing":"1px","fontSize":"20px","fontFamily":"Roboto Slab, serif","textTransform":"uppercase","textAlign":"center"}} class="">Spicejet</td>
                              </tr>
                              <tr>
                                  <td style={{"paddingTop":"15px","transform":"uppercase"}} class="">
                                      <span style={{"fontWeight":"600","fontSize":"16px","wordBreak":"break-all"}} class=""> {item.name.last+"/"+item.name.first}</span><br />
                                      <span style={{"fontWeight":"600","fontSize":"16px"}} class="">{recordLocator}</span><br />
                                      <small>{bt.destAtTop}</small><br />
                                      <small>Seq. No.: {bt.seqAtTop}</small><br />
                                      <small>{bt.flightnumberAtTop}</small>
                                  </td>
                              </tr>
                              <tr>
                                  <td style={{"paddingTop":"15px"}}  class="">
                                      <div id="barcodeTarget"  style={{"width":"190px","marginLeft":"auto","marginRight":"auto"}}  class="">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128', text:"SG "+bt.osTagUnderBarCode, height: "80px",width: 2 ,fontSize: 20,fontOptions: "bold" , font:"Roboto Slab, serif"}} renderer="svg" />

                                      </div>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </td>
              </tr>
              <tr>
              {/* <td height= "145">&nbsp;</td> */}
                  <td height={bt.table.length > 1 ? "70" : "145"}>&nbsp;</td>
                  {/* <td height={bt.table.length > 1 ? "15" : "90"}>&nbsp;</td> */}
              </tr>
              <tr>
                  <td height="250"  valign="top" style={{"width":"100%"}}>
                      <table style={{"WebkitTransform":"rotate(180deg)","transform":"rotate(180deg)"}} border="0" cellspacing="0" cellpadding="0" width="100%" class="">
                          <tr>
                              <td valign="bottom" style={{"padding":"10px"}} class="">
                                  <small style={{"wordBreak":"break-all"}} >{item.name.last+"/"+item.name.first}</small><br/>
                                  <small>PNR: {recordLocator}</small><br/>
                                  <small>Tag No.: SG &nbsp; {bt.osTagUnderBarCode}</small><br/>
                                  <small>Baggage weight: {bt.weight} KG</small><br/>
                                  <small>Total Pieces: {item.bags.filter(items => items.IsSelected).length}</small><br/>
                                  <small>Origin: {bt.origin}</small>
                              </td>
                                <td width="30" class="" style={{"background-color": "black" ,"color": "white" ,"padding-top": "8px" ,"padding-bottom": "8px" ,"font-size": "16px", "font-weight": "700", "vertical-align": "middle", "text-align": "center", "font-family": "Roboto Slab, serif"}}>
                              <svg width="30" height="100">
                                  <text x="-40" y="103" transform="rotate(90 15,100)" font-size="14" text-anchor="middle" fill="#fff">
                                  SEQ. NO.: {bt.seqAtTop}
                                  </text>
                              </svg>
                          </td>
                              {/* <td style={{"backgroundColor":"black","color":"white","paddingTop":"8px","paddingBottom":"8px","fontSize":"16px","fontWeight": "700","verticalAlign":"bottom","textAlign":"center","fontFamily":"Roboto Slab, serif"}} width="30" class="">
                                  <span style={{"msWritingMode":"tb-rl","WebkitWritingMode":"vertical-rl","writingMode":"vertical-rl","WebkitTransform":"rotate(180deg)","transform":"rotate(180deg)","whiteSpace":"nowrap"}}>SEQ. NO.: {bt.seqAtTop}</span>
                              </td> */}
                          </tr> 
                          {/* <tr>
                              <td height="80" colspan="2" class="sj-border-top sj-border-bottom sj-py-10 sj-py-5 text-center">
                                  <table border="0" cellspacing="0" cellpadding="0" width="100%">
                                      <tr>
                                          <td rowspan="2">
                                              <span class="sj-bg-black sj-p-5 sj-fw-700 sj-fs-50">
                                              {bt.taggedToStation}
                                              </span>
                                          </td>
                                          <td class="text-uppercase">
                                              <div class="sj-fs-25 sj-fw-700 sj-line-height-20">{flightnumber}</div>
                                              <span class="sj-fs-12">{moment(departureDate).format("D MMM, YYYY")}</span>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td class="sj-pt-5">
                                              <span class="sj-bg-black sj-px-10 sj-py-5 sj-fs-14">SEQ - 112</span>
                                          </td>
                                      </tr>
                                  </table>
                              </td>
                          </tr> */}
                          {
                              bt.table.map((trow, index, array) =>
                          <tr>
                              <td height="80" colspan="2" style={{"borderTop":"2px black solid","borderBottom":"2px black solid","paddingTop":"5px","paddingBottom":"5px","paddingTop":"10px","paddingBottom":"10px","textAlign":"center"}} class="">
                                  <table border="0" cellspacing="0" cellpadding="0" width="100%">
                                
                                          <tbody>
                                              <tr>
                                              { array.length > 1 && index === 0 ? <td rowspan="2">
                                                <span style={{"display":"inline-block","color":"black","padding":"5px","fontWeight":"700","fontSize":"37px"}}   class="">
                                                {trow.taggedToStation}
                                                </span> </td> : <td rowspan="2">
                                                    <span style={{"display":"inline-block","backgroundColor":"black","color":"white","padding":"5px","fontWeight":"700","fontSize":"37px"}}   class="">
                                                    {trow.taggedToStation}
                                                    </span>
                                                </td>
                                            
                                                
                                              }
                                                
                                                <td class="" style={{"transform":"uppercase"}}>
                                                    <div style={{"lineHeight":"20px","fontWeight":"700","fontSize":"20px"}} class="">{trow.flightNumber}</div>
                                                    <span style={{"fontSize":"12px"}} class="">{trow.depDate}</span>
                                                </td>
                                                </tr>
                                                <tr>
                                                    <td class="" style={{"paddingTop":"5px"}}>
                                                        <span style={{"display":"inline-block","backgroundColor":"black","color":"white","paddingTop":"5px","paddingBottom":"5px","paddingLeft":"10px","paddingRight":"10px","fontSize":"14px", "fontWeight": "700"}} class="">SEQ - {trow.seqNo}</span>
                                                    </td>
                                                </tr> 
                                                <tr> 
                                                    
                                                </tr>                                 
                                          </tbody>
                                       
                                  </table>
                              </td>
                          </tr>
                        )
                        }                       
                      </table>
                  </td>
              </tr>
              
              <tr>

                  <td height="568" class="" style={{"textAlign":"center","paddingTop":"15px"}}> 
                  <table style={{"WebkitTransform":"rotate(90deg)","transform":"rotate(90deg)"}} border="0" cellspacing="0" cellpadding="0" width="100%" class="">                          
                          <tr>
                              <td valign="bottom" class="">
                              <div id="barcodeTarget2"   style={{"width":"190px","marginLeft":"auto","marginRight":"auto"}}  class="text-fs-12">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128',text:'',height: "180px",width: 2 ,fontSize: 12,margin: 0,flat: true,ean128: true, displayValue:false}} renderer="svg" />

                                  </div>
                              </td>
                          </tr>
                      </table> 
                  <table border="0" cellspacing="0" cellpadding="0" width="100%"  >                          
                          <tr>
                              <td style={{"paddingTop":"5px"}} valign="bottom" class="">
                              <div id="barcodeTarget2"  style={{"width":"190px","marginLeft":"auto","marginRight":"auto","paddingTop":"30px"}}    class="text-fs-12">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128',text: '' ,height: "80px",width: 2 ,fontSize: 12,margin: 0,displayValue:false}} renderer="svg" />

                                  </div>
                              </td>
                          </tr>
                      </table>                     
                      <table style={{"WebkitTransform":"rotate(180deg)","transform":"rotate(180deg)"}} border="0" cellspacing="0" cellpadding="0" width="100%" >                          
                          <tr>
                              <td style={{"paddingTop":"15px","paddingBottom":"15px"}} valign="bottom" class="">
                                  {
                                      bt.type === 'LRT' ?
                                      <span style={{"backgroundColor":"black","color":"white","padding":"5px","fontWeight":"700","fontSize":"20px","fontFamily":"Roboto Slab, serif","transform":"uppercase"}} class="">
                                          LRT
                                      </span> : 
                                      <span style={{"backgroundColor":"black","color":"white","padding":"5px","fontWeight":"700","fontSize":"20px","fontFamily":"Roboto Slab, serif","transform":"uppercase"}} class="">
                                          Registered <br/> Baggage
                                      </span>
                                  }
                                  
                              </td>
                          </tr>
                      </table>
                      <table border="0" cellspacing="0" cellpadding="0" width="100%" class="">                          
                          <tr>
                              <td style={{"paddingBottom":"5px"}} valign="bottom" class="">
                              <div id="barcodeTarget2"    style={{"width":"190px","marginLeft":"auto","marginRight":"auto"}}    class="text-fs-12">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128',text: '',height: "80px",width: 2 ,fontSize: 12,margin: 0,displayValue:false}} renderer="svg" />
                              </div>
                              </td>
                          </tr>
                      </table> 
                      <table style={{"WebkitTransform":"rotate(90deg)","transform":"rotate(90deg)"}} border="0" cellspacing="0" cellpadding="0" width="100%" class="">                          
                          <tr>
                              <td valign="bottom" class="">
                              <div id="barcodeTarget2"    style={{"width":"190px","marginLeft":"auto","marginRight":"auto","paddingTop":"10px","paddingBottom":"10px","paddingLeft":"10px","paddingRight":"10px"}} class="text-fs-12">
                              <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128',text:'',height: "180px",width: 2 ,fontSize: 12,margin: 0,flat: true,ean128: true, displayValue:false}} renderer="svg" />
            

                                  </div>
                              </td>
                          </tr>
                      </table> 
                  </td>
              </tr>
      
              <tr>
                  <td height="250"  valign="top" width="100%" style={{"paddingTop":"30px"}}>
                      <table border="0" cellspacing="0" cellpadding="0" width="100%">
                          <tr>
                              <td valign="bottom"  style={{"padding":"10px"}}  class="">
                                  <small style={{"wordBreak":"break-all"}}>{item.name.last+"/"+item.name.first}</small><br/>
                                  <small>PNR: {recordLocator}</small><br/>
                                  <small>Tag No.: SG &nbsp; {bt.osTagUnderBarCode}</small><br/>
                                  <small>Baggage weight: {bt.weight} KG</small><br/>
                                  <small>Total Pieces: {item.bags.filter(items => items.IsSelected).length}</small><br/>
                                  <small>Origin: {bt.origin}</small>
                              </td>
                              <td width="30" class="" style={{"background-color": "black" ,"color": "white" ,"padding-top": "8px" ,"padding-bottom": "8px" ,"font-size": "16px", "font-weight": "700", "vertical-align": "middle", "text-align": "center", "font-family": "Roboto Slab, serif"}}>
                              <svg width="30" height="100">
                                  <text x="-40" y="103" transform="rotate(90 15,100)" font-size="14" text-anchor="middle" fill="#fff">
                                  SEQ. NO.: {bt.seqAtTop}
                                  </text>
                              </svg>
                          </td>
                              {/* <td style={{"backgroundColor":"black","color":"white","paddingTop":"8px","paddingBottom":"8px","fontSize":"16px","fontWeight": "700","verticalAlign":"bottom","textAlign":"center","fontFamily":"Roboto Slab, serif"}} width="30" class="">
                                  <span style={{"msWritingMode":"tb-rl","WebkitWritingMode":"vertical-rl","writingMode":"vertical-rl","WebkitTransform":"rotate(180deg)","transform":"rotate(180deg)","whiteSpace":"nowrap"}}>SEQ. NO.: {bt.seqAtTop}</span>
                              </td> */}
                          </tr>
                          {
                              bt.table.map((trow, index, array) =>
                          <tr>
                              <td height="80" colspan="2" style={{"borderTop":"2px black solid","borderBottom":"2px black solid","paddingTop":"5px","paddingBottom":"5px","paddingTop":"10px","paddingBottom":"10px","textAlign":"center"}} class="">
                                  <table border="0" cellspacing="0" cellpadding="0" width="100%">
                                
                                          <tbody>
                                              <tr>
                                              { array.length > 1 && index === 0 ? <td rowspan="2">
                                                <span style={{"display":"inline-block","color":"black","padding":"5px","fontWeight":"700","fontSize":"37px"}}   class="">
                                                {trow.taggedToStation}
                                                </span> </td> : <td rowspan="2">
                                                    <span style={{"display":"inline-block","backgroundColor":"black","color":"white","padding":"5px","fontWeight":"700","fontSize":"37px"}}   class="">
                                                    {trow.taggedToStation}
                                                    </span>
                                                </td>
                                            
                                                
                                              }
                                                <td class="" style={{"transform":"uppercase"}}>
                                                    <div style={{"lineHeight":"20px","fontWeight":"700","fontSize":"20px"}} class="">{trow.flightNumber}</div>
                                                    <span style={{"fontSize":"12px"}} class="">{trow.depDate}</span>
                                                </td>
                                                </tr>
                                                <tr>
                                                    <td class="" style={{"paddingTop":"5px"}}>
                                                        <span style={{"display":"inline-block","backgroundColor":"black","color":"white","paddingTop":"5px","paddingBottom":"5px","paddingLeft":"10px","paddingRight":"10px","fontSize":"14px", "fontWeight": "700"}} class="">SEQ - {trow.seqNo}</span>
                                                    </td>
                                                </tr> 
                                                <tr> 
                                                    
                                                </tr>                                 
                                          </tbody>
                                       
                                  </table>
                              </td>
                          </tr>
                        )
                        }
                      </table>
                  </td>
              </tr>    
               {
                  bt.table.length === 1 ? 
                <tr>
                    <td height="120">&nbsp;</td>
                    {/* height="90"  145 */}
                </tr> : <tr>
                    <td height="55">&nbsp;</td>
                    {/* height="50" 80*/}
                </tr>
                }
              <tr>
                  <td height={bt.table.length > 1 ? "220" : "250"} valign="bottom" style={{"padding":"10px","width":"auto !important"}}  class="">
                      <table align="center">
                          <tr>
                              <td>
                                  <div id="barcodeTarget2"   style={{"width":"190px","marginLeft":"auto","marginRight":"auto"}}   class="text-fs-12">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128', text:`SG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}`, height: "40px",width: 2 ,fontSize: 12 ,margin: 0}} renderer="svg" />

                                  </div>
                              </td>
                          </tr>
                          <tr>
                              <td style={{"paddingTop":"10px"}} class="">
                                  <div id="barcodeTarget3"   style={{"width":"190px","marginLeft":"auto","marginRight":"auto"}}   class="text-fs-12">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128', text:`SG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}`, height: "40px",width: 2 ,fontSize: 12,margin: 0}} renderer="svg" />

                                  
                                  </div>
                              </td>
                          </tr>
                          <tr>
                              <td style={{"paddingTop":"10px"}}  class="">
                                  <div id="barcodeTarget4"   style={{"width":"190px","marginLeft":"auto","marginRight":"auto"}}    class="text-fs-12">
                  <ReactJSBarcode value={bt.osTagUnderBarCode} options={{ format: 'code128', text:`SG${bt.osTagUnderBarCode}${a} Seq-${bt.seqAtTop}`, height: "40px",width: 2 ,fontSize: 12,margin: 0}} renderer="svg" />

                                 
                                  </div>
                              </td>
                          </tr>
                      </table>
                  </td>
              </tr>
          </table>
          </td></tr>
          {additionalTrForDirectAndConnecting(bt, item, j)}
          
          </table>
          </div>

    //   : null
      ))}
    </div>
 
  );
}

export default BagTag;